<label class="{{ cssClass }} side-{{ side }}" [class.disabled]="disabled" [class.checked]="isChecked">
  <input
    type="checkbox"
    [name]="name"
    [checked]="isChecked"
    [disabled]="disabled"
    [id]="inputId"
    [attr.aria-checked]="isChecked"
    [attr.aria-disabled]="disabled ? 'true' : null"
    [attr.aria-label]="ariaLabel"
    [attr.aria-describedby]="ariaDescribedby"
    (change)="onCheckboxChange($event)"
  />
  @if (cssClass === 'checkbox-container') {
  <span class="checkmark"><i class="fa fa-check"></i></span>
  }
  <ng-content></ng-content>
</label>
